<template> 
    <div class="row g-6 g-xl-9">  
        <div class="col-12 col-md-12 col-xl-12"> 
            <EnderecoIndex  :model_watch="model_watch" :modal_cadastro="modal_cadastro"/>  
        </div> 
    </div>  
</template>

<script lang="ts">
    import EnderecoIndex from   "./_Index.vue"  
      
    import { Options, Vue  } from "vue-class-component";   
      
    @Options({
        name: "Endereco",
        components: { EnderecoIndex  },  
    }) 
    export default class Endereco extends Vue {
        public modal_cadastro ;
        public model_watch  = false ;
        created(){ 
            this.modal_cadastro = 'kt_cadatrar_endereco_profile';
		}
        public modeloAlterado(){  
             this.model_watch = !this.model_watch;
        }
    }
</script> 